export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更完成公告_sc-d145f5f1fce2d3ed9b660477432d0294.webp";